<template>
  <div class="bg-initial">
    <v-container fluid fill-height class="overlay">
      <v-row
        align="center"
        justify="center"
      >
        <v-col cols="12" class="login-card">
          <px-floating-card
            color="primary"
            class="mx-auto"
            max-width="400"
          >
            <div slot="header">
              <v-card-text align="center">
                <v-row align="center" justify="center">
                  <img class="logo" src="../../assets/logo-branca.png"
                       alt="Logo da Proxpect"/>
                </v-row>
              </v-card-text>
            </div>
            <div class="error--text"
                 v-if="error"
                 align="center">
              {{ error }}
            </div>
            <v-form
              class="login-content"
              ref="form"
            >
              <v-text-field
                solo
                v-model="user"
                :error="$v.user.$error"
                @blur="$v.user.$touch()"
                class="rounded-tag-small"
                label="Usuário"
                required
              />
              <v-text-field
                solo
                v-model="password"
                label="Senha"
                class="rounded-tag-small"
                :type="passwordType"
                @click:append="onClickShowPassword()"
                :append-icon="passwordIcon"
                :error="$v.password.$error"
                @blur="$v.password.$touch()"
                v-on:keyup.enter="doLogin"
                hide-details
                required
              />
            </v-form>
            <v-row dense no-gutters class="mt-2 text-right">
              <v-col cols="12">
                <px-dialog-esqueceu-senha/>
              </v-col>
            </v-row>
            <div slot="actions">
              <v-btn color="primary"
                     class="elevation-0"
                     :disabled="$v.$invalid"
                     :loading="loading"
                     @click="doLogin">Entrar
              </v-btn>
            </div>
          </px-floating-card>
        </v-col>
        <v-row dense no-gutters class="text-center caption white--text">
          <v-col cols="12">
            protected by reCAPTCHA
          </v-col>
        </v-row>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapGetters } from 'vuex';
import EventService from '@/events';
// eslint-disable-next-line import/no-cycle
import axios from '@/plugins/axios/axios-config';
import DialogEsqueceuSenha from '@/modules/login/DialogEsqueceuSenha.vue';
import { LOGIN } from './store/actions.type';

const recaptchaKey = process.env.VUE_APP_RECAPTCHA_KEY;

export default {
  data() {
    return {
      showPassword: false,
    };
  },
  computed: {
    ...mapGetters('login', {
      loading: 'loading',
      error: 'error',
    }),
    user: {
      get() {
        return this.$store.getters['login/user'];
      },
      set(user) {
        this.$store.dispatch('login/user', user);
      },
    },
    password: {
      get() {
        return this.$store.getters['login/password'];
      },
      set(password) {
        this.$store.dispatch('login/password', password);
      },
    },
    passwordType() {
      if (this.showPassword) {
        return 'text';
      }
      return 'password';
    },
    passwordIcon() {
      if (this.showPassword) {
        return 'mdi-eye-off';
      }
      return 'mdi-eye';
    },
  },
  methods: {
    ...mapActions('login', {
      logar: LOGIN,
    }),
    async doLogin() {
      if (!this.user || !this.password) {
        return;
      }
      const recaptchaToken = recaptchaKey ? await this.recaptcha() : undefined;

      this.logar(recaptchaToken).then(() => {
        if (this.$route.query.redirect) {
          window.location = this.$route.query.redirect;
          return;
        }
        this.$router.push({ name: 'selecao-entidade' });
        EventService.createLogin(axios, null);
      });
    },
    onClickShowPassword() {
      this.showPassword = !this.showPassword;
    },
    async recaptcha() {
      await this.$recaptchaLoaded();
      return this.$recaptcha();
    },
  },
  validations: {
    user: {
      required,
    },
    password: {
      required,
    },
  },
  components: {
    pxDialogEsqueceuSenha: DialogEsqueceuSenha,
  },
};
</script>

<style scoped>
.logo {
  width: 200px;
  margin-top: 30px;
  margin-bottom: 30px;
}

.login-content {
  padding-top: 15px;
}
</style>
